import { useDispatch, useSelector } from 'react-redux';
import {
  PersistedUiState,
  setPageAction,
} from 'src/store/slices/persistedUiSlice';

interface PersistedUiSliceState {
  persistedUi: PersistedUiState;
}

const FIRST_PAGE: number = 1;

/* Named page-state shape consumed by `useClientPagination`'s `pageState` prop.
 * The page number lives in redux, so it survives unmount — leaving the page and
 * returning reads the saved page with no restore logic. */
export interface PageState {
  page: number;
  setPage: (page: number) => void;
}

export const usePersistedPageState = (
  key?: string
): PageState | undefined => {
  const dispatch = useDispatch();

  const page = useSelector((state: PersistedUiSliceState) =>
    key ? (state.persistedUi[key] as number) ?? FIRST_PAGE : FIRST_PAGE
  );

  if (!key) {
    return undefined;
  }

  const setPage = (nextPage: number): void => {
    dispatch(setPageAction({ key, page: nextPage }));
  };

  return { page, setPage };
};
